import isEmptyObject from '../../utils/isEmptyObject';

const getEmptyDataRedirect = (params, data, errors) => {
  if (errors && !data) return '/';
  if (!params) return false;
  if (!data) return false;

  const {
    data: [dataObj],
  } = data;
  const { attributes } = dataObj || {};

  if (!attributes) return false;
  const { regions } = attributes || {};
  if (isEmptyObject(regions)) return '/';

  return false;
};

const redirects = ({ params, data: searchSeoState, errors }) => {
  // const { searchSeoState } = data || {}; # REVERT GRAPHQL
  const redirectArray = [getEmptyDataRedirect(params, searchSeoState, errors)];

  return redirectArray.find(url => url);
};

export default redirects;
